import { render } from "./Stones.vue?vue&type=template&id=260e4f33&scoped=true&lang=html"
import script from "./Stones.vue?vue&type=script&lang=js"
export * from "./Stones.vue?vue&type=script&lang=js"

import "./Stones.vue?vue&type=style&index=0&id=260e4f33&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260e4f33"]])

export default __exports__